import { EventEmitter } from '@angular/core';
import { IdleInterruptArgs } from './interrupt-args';
import { IdleInterruptOptions } from './interrupt-options';

/**
 * A base for classes that act as a source for interrupts.
 */
export abstract class IdleInterruptSource {
    isAttached = false;

    public onInterrupt: EventEmitter<IdleInterruptArgs> = new EventEmitter<IdleInterruptArgs>();

    constructor(protected attachFn?: (source: IdleInterruptSource) => void, protected detachFn?: (source: IdleInterruptSource) => void) {}

    /**
     * Attaches to the specified events on the specified source.
     */
    attach(): void {
        if (!this.isAttached && this.attachFn) {
            this.attachFn(this);
        }

        this.isAttached = true;
    }

    /**
     * Detaches from the specified events on the specified source.
     */
    detach(): void {
        if (this.isAttached && this.detachFn) {
            this.detachFn(this);
        }

        this.isAttached = false;
    }

    initialize?(options?: IdleInterruptOptions): void;
}
